import Cookies from 'universal-cookie';
import {
	type Cookie,
	type CookieGetOptions,
	type CookieSetOptions,
} from 'universal-cookie/cjs/types';
import { isObject } from '@/helpers/isObject';

const cookiesInstance = new Cookies();

export const CookiesStorageService = {
	getAll(options?: CookieGetOptions) {
		return cookiesInstance.getAll(options);
	},
	get<T>(key: string, defaultValue: T): T {
		const saved = cookiesInstance.get(key);

		try {
			const initial = JSON.parse(saved) as T;
			return initial ?? defaultValue;
		} catch (error) {
			return saved ?? defaultValue;
		}
	},
	set(key: string, value: Cookie, options?: CookieSetOptions) {
		cookiesInstance.set(key, isObject(value) ? JSON.stringify(value) : value, {
			path: '/',
			expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
			...options,
		});
	},
	remove(key: string, options?: CookieSetOptions) {
		cookiesInstance.remove(key, {
			path: '/',
			...options,
		});
	},
	removeFromAllDomains(key: string, options?: CookieSetOptions) {
		if (typeof window === 'undefined') {
			cookiesInstance.remove(key, { path: '/', ...options });
			return;
		}

		const { hostname } = window.location;
		const parts = hostname.split('.');
		const domains = new Set<string | undefined>();
		domains.add(undefined);
		domains.add(hostname);
		domains.add(`.${hostname}`);
		for (let i = 1; i < parts.length - 1; i += 1) {
			const parent = parts.slice(i).join('.');
			domains.add(parent);
			domains.add(`.${parent}`);
		}

		const paths: Array<string | undefined> = ['/', undefined];

		domains.forEach(domain => {
			paths.forEach(path => {
				cookiesInstance.remove(key, { ...options, path, domain });
			});
		});
	},
	removeSelected(selectedKeys: string[]) {
		selectedKeys.forEach(key => {
			cookiesInstance.remove(key);
		});
	},
	clear(getOptions?: CookieGetOptions, removeOptions?: CookieSetOptions) {
		Object.keys(cookiesInstance.getAll(getOptions)).forEach(key => {
			cookiesInstance.remove(key, removeOptions);
		});
	},
};
